<mat-progress-spinner [diameter]="40" color="primary" mode="determinate"
  [value]="timeoutData.displayValueInversePercent">
</mat-progress-spinner>